module.exports = "<body>\n    <main>\n        <router-outlet></router-outlet>\n    </main>\n</body>"